/* eslint react/jsx-filename-extension: 0 */
import React from "react";
import { Route, Switch } from "react-router-dom";
import RecommendationDashboard from "./dashboard";

const RoutingLogic = () => (
  <Switch>
    <Route path="/:dashboardId" component={RecommendationDashboard} />
  </Switch>
);

export default RoutingLogic;
